import { recommendedProfessionalsAdapter } from './recommendedProfessionalsAdapter';
import {
  IGetRecommendedProfessionalsParams,
  recommendedProfessionalsApi,
} from './recommendedProfessionalsApi';
import { IRecommendedProfessional } from './recommendedProfessionalsTypes';

async function getRecommendedProfessionals(
  params: IGetRecommendedProfessionalsParams,
): Promise<IRecommendedProfessional[]> {
  const recommendedProfessionalsAPI =
    await recommendedProfessionalsApi.getRecommendedProfessionals(params);

  return recommendedProfessionalsAPI.map(
    recommendedProfessionalsAdapter.toRecommendedProfessionals,
  );
}

export const recommendedProfessionalsService = {
  getRecommendedProfessionals,
};
